import { makeStyles } from "@material-ui/core";

export const usePagingStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      marginTop: theme.spacing(2),
    }
  },
  rootSmall: {
    display: 'block',
    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
  pageDetail: {
    marginLeft: theme.spacing(1),
    whiteSpace: 'nowrap',
  }
}));
